import React, { useState, useEffect } from 'react';
import { apiService } from '../ApiService';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';
import { AddAllItem } from '../../reducetool/features/cardSlice';
import ProductList from '../../pages/Product/ProductList';

const Header = ({companyDetail}) => {


    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    //useScript('./assets/js/theme-setting.js');

    const [categoryTable, setCategoryTable] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const shoppingCart = useSelector(state => state.cardState);
    const authData = useSelector(state => state.authState);
    const [searchKeyData, setSearchKeyData] = useState("");
    const [showCategory, setShowCategory] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const showCategoryFx = () => {
        if (showCategory === true) {
            setShowCategory(false);
        } else {
            setShowCategory(true);
        }
    }
    

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".onhover-dropdown")) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    const getCategoryData = async (page = 1, limit = 10, search = "") => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/CategoryMaster/allcategory?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                // console.log(response.categoryMasterData)
                setCategoryTable(response.categoryMasterData)
                // setTotalPage(response.totalPages)
                // console.log(response.message);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    };

    const getAddToCartData = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/AddToCartMaster/addToCartByUserId`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                if (response.addToCartMasterData.length != 0) {
                    dispatch(AddAllItem(response.addToCartMasterData))
                }
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }


    }

    useEffect(() => {
        getAddToCartData();
        getCategoryData();
    }, [authData.login, !categoryTable]);

    const userLogout = () => {
        navigate("/Login")
        dispatch(resetToken())
        dispatch(allRemoveItem())
        return
    }


    const goToProductList = (categoryName, subcategoryName) => {
        // navigate(`/ProductList?categoryName=${categoryName}&subcategoryName=${subcategoryName}`);
        setShowCategory(false);
        navigate('/ProductList', { state: { categoryName: categoryName, subcategoryName: subcategoryName } });
    }



    const onHandleSearchKeyItem = () => {
        navigate("/searchProduct", { state: { searchKey: searchKeyData } })
    }

    return (
        <>

            <style>
                {`
            .right-side {
  position: relative;
}
.onhover-div-login {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #eee;
  padding: 10px;
  z-index: 1000;
  width: 200px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.onhover-div-login.show {
  display: block;
}
            `}
            </style>

            {/* Header Start */}
            <header className="pb-0 bg-light shadow sticky-top inter-font" style={{ zIndex: 1030 }}>
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="header-nav d-flex justify-content-between align-items-center ">
                                <div className="header-nav-left">
                                    <button
                                        className="navbar-toggler d-xl-none d-inline navbar-menu-button"
                                        type="button"
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#primaryMenu"
                                    >
                                        <span className="navbar-toggler-icon">
                                            <i className="fa-solid fa-bars" />
                                        </span>
                                    </button>

                                    <Link to="/" className="web-logo nav-logo">
                                        <img
                                            style={{ height: "10vh" }}
                                            src={process.env.REACT_APP_API_BASE_URL +companyDetail.company_img_url}
                                            // src="../assets/images/logo/Valorelle_Logo.png"
                                            className="img-fluid lazyload"
                                            alt=""
                                        />
                                    </Link>
                                </div>



                                <div class="header-nav-middle">
                                    <div className="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
                                        <div
                                            className="offcanvas offcanvas-start offcanvas-collapse order-xl-2"
                                            id="primaryMenu"
                                            tabIndex="-1"
                                            aria-labelledby="offcanvasLabel"
                                        >
                                            <div className="offcanvas-header navbar-shadow">
                                                <h5>Menu</h5>
                                                <button
                                                    className="btn-close lead"
                                                    type="button"
                                                    data-bs-dismiss="offcanvas"
                                                    aria-label="Close"
                                                />
                                            </div>
                                            <div className="offcanvas-body">
                                                <ul className="navbar-nav">
                                                    <li className="nav-item">
                                                        <Link
                                                            className="nav-link"
                                                            to="/"
                                                        >
                                                            Home
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item dropdown">
                                                        <Link
                                                            className="nav-link"
                                                            to="/about"
                                                        >
                                                            About Us
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item">
                                                        <Link
                                                            className="nav-link"
                                                            to="/ProductList"
                                                        >
                                                            Product Collection
                                                        </Link>
                                                    </li>

                                                    <li className="nav-item dropdown">
                                                        <Link className="nav-link" to="/faq">FAQ's</Link>
                                                    </li>


                                                    <li className="nav-item dropdown">
                                                        <Link className="nav-link" to="/contact-us">Contact Us</Link>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="header-nav-right d-flex align-items-center ms-auto">
                                    <ul className="right-side-menu d-flex align-items-center gap-3 list-unstyled mb-0">

                                        {/* Cart Icon */}
                                        <li className="right-side">
                                            <div className="onhover-dropdown header-badge">
                                                <button
                                                    type="button"
                                                    onClick={() => { navigate("/Cart") }}
                                                    className="btn p-0 position-relative header-wishlist"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                                        className="feather feather-shopping-cart">
                                                        <circle cx="9" cy="21" r="1" />
                                                        <circle cx="20" cy="21" r="1" />
                                                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                                                    </svg>
                                                    <span className="position-absolute top-0 start-100 translate-middle badge bg-danger rounded-circle">
                                                        {shoppingCart?.items?.length || 0}
                                                    </span>
                                                </button>
                                            </div>
                                        </li>

                                        {/* My Account */}
                                        <li className="right-side onhover-dropdown">
                                            <div className="delivery-login-box d-flex align-items-center gap-2" onClick={() => setIsDropdownOpen((prev) => !prev)}
                                                style={{ cursor: "pointer" }}>
                                                <div className="delivery-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                                        className="feather feather-user">
                                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                                        <circle cx="12" cy="7" r="4" />
                                                    </svg>
                                                </div>
                                                {/* <div className="delivery-detail"><h6 className="mb-0">{authData?.user_name || "Guest"}</h6><h5 className="mb-0">My Account</h5></div> */}
                                            </div>

                                            {/* Dropdown for Account Options */}
                                            <div className={`onhover-div onhover-div-login ${isDropdownOpen ? "show" : ""}`}>
                                                <ul className="user-box-name list-unstyled">
                                                    {!authData?.login ? (
                                                        <>
                                                            <li><Link to="/Register">Register</Link></li>
                                                            <li><Link to="/Login">Log In</Link></li>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <li><Link to="/user-dashboard">Your Profile</Link></li>
                                                            <li><a onClick={userLogout}>Log Out</a></li>
                                                        </>
                                                    )}
                                                </ul>
                                            </div>
                                        </li>
                                    </ul>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </header>
            {/* Header End */}
            {/* mobile fix menu start */}
            <div className="mobile-menu d-md-none d-block mobile-cart">

                <ul>
                    <li className={isActive('/') ? 'active' : ''}>
                        <NavLink to="/">
                            <i className="iconly-Home icli" />
                            <span>Home</span>
                        </NavLink>
                    </li>
                    {/* <li className="mobile-category">
                        <a onClick={showCategoryFx} href="javascript:void(0)">
                            <i className="iconly-Category icli js-link" />
                            <span>Category</span>
                        </a>
                    </li> */}
                    <li className={isActive('/searchProduct') ? 'active' : ''}>
                        <NavLink to="/searchProduct" className="search-box">
                            <i className="iconly-Search icli" />
                            <span>Search</span>
                        </NavLink>
                    </li>
                    {/* <li>
                        <a href="wishlist.html" className="notifi-wishlist">
                            <i className="iconly-Heart icli" />
                            <span>My Wish</span>
                        </a>
                    </li> */}
                    <li className={isActive('/Cart') ? 'active' : ''}>
                        <NavLink to="/Cart">
                            <i className="iconly-Bag-2 icli fly-cate" />
                            <span>Cart</span>
                        </NavLink>
                    </li>
                    <li className={isActive('/user-dashboard') ? 'active' : ''}>
                        <NavLink to={!authData?.login ? '/Login' : '/user-dashboard'}>
                            <i className="iconly-Profile icli" />
                            <span>Account</span>
                        </NavLink>
                    </li>
                </ul>
            </div>
            {/* mobile fix menu end */}

            <div onClick={showCategoryFx} className={showCategory ? "bg-overlay show " : "bg-overlay"}></div>

        </>

    )

}

export default Header;